import React, { Component } from "react";
import TimePicker from "rc-time-picker";
import M from "moment";

class TimeMinuteDD extends Component {
  constructor(props) {
    super(props);
    this.state = {
      timeState: this.props.time ? M(this.props.time, "HH:mm") : null,
    };
  }

  componentDidUpdate(prevProps) {
    if (prevProps.time !== this.props.time) {
      this.setState({
        timeState: this.props.time ? M(this.props.time, "HH:mm") : null,
      });
    }
  }

  onTimeChange = (options) => {
    if (!options) return;

    const hour = options.hour();
    const minute = options.minute();
    const prev = this.state.timeState;
    const prevIsNull = prev === null;

    const time = M({ hour, minute });
    this.setState({ timeState: time });
    if (prevIsNull) {
      return;
    }
    if (prev.hour() !== hour && prev.minute() === minute) {
      return;
    }

    this.props.onChange(time.format("HH:mm"));
  };

  // onTimeChange = (options) => {
  //   if (!options) return;

  //   const time = M(options);
  //   this.setState({ timeState: time });

  //   this.props.onChange(time.format("HH:mm"));
  // };

  render() {
    let { align } = this.props;

    return (
      <div
        className="card-time-picker"
        style={{ marginBottom: 12, textAlignLast: align || "center" }}
      >
        <TimePicker
          placeholder={"hh : mm"}
          value={this.state.timeState}
          onChange={this.onTimeChange}
          showSecond={false}
          allowEmpty={false}
          minuteStep={1}
          style={{ width: 100 }}
          disabled={this.props.disabled}
        />
      </div>
    );
  }
}

export default TimeMinuteDD;
